import { AsyncPipe } from '@angular/common';
import { Component, inject } from '@angular/core';
import {
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from '@angular/material/dialog';
import { Store } from '@ngrx/store';
import dayjs from 'dayjs';
import moment from 'moment';
import { Observable, of, Subject, takeUntil } from 'rxjs';
import { Grade } from '../../../../models/grade.school.model';
import { Group } from '../../../../models/group.model';
import { SchoolGradeLessonService } from '../../../../services/grade-lesson.school.service';
import { UtilsService } from '../../../../services/utils.service';
import { AppState } from '../../../../state/appstate';
import * as gradeSelector from '../../../../state/selectors/grade.school.selector';
import * as groupSelector from '../../../../state/selectors/group.selector';
import { BtnSubmitComponent } from '../../../components/buttons/btn-submit/btn-submit.component';
import { DlgAddToGradeComponent } from '../dlg-add-to-grade/dlg-add-to-grade.component';

@Component({
  selector: 'dlg-lessons-filters',
  standalone: true,
  imports: [BtnSubmitComponent, AsyncPipe, FormsModule, ReactiveFormsModule],
  templateUrl: './dlg-lessons-filters.component.html',
  styleUrl: './dlg-lessons-filters.component.css',
})
export class DlgLessonsFiltersComponent {
  store: Store<AppState> = inject(Store<AppState>);
  lessonService: SchoolGradeLessonService = inject(SchoolGradeLessonService);
  utilsService = inject(UtilsService);
  readonly dialogRef = inject(MatDialogRef<DlgAddToGradeComponent>);
  private dialog: MatDialog = inject(MatDialog);

  readonly data = inject<any>(MAT_DIALOG_DATA);
  pageForm: FormGroup;

  group: Group | undefined;
  grades: Grade[] = [];

  title: string = 'Apply Filter(s)';
  description: string = 'Select filters to apply to lessons';
  action: string = 'Apply';

  loading$: Observable<boolean> = of(false);

  exit$: Subject<void> = new Subject<void>();

  minTime = dayjs().format('YYYY-MM-DDTHH:mm');

  constructor() {
    this.title = this.data.title;
    this.description = this.data.description;
    this.action = this.data.action;

    this.pageForm = new FormGroup({
      gradeId: new FormControl(this.data.lesson.gradeId, [Validators.required]),
      publishBy: new FormControl(moment().format('YYYY-MM-DDTHH:mm')),
    });
  }

  ngOnInit(): void {
    this.store
      .select(groupSelector.getGroupById(this.data.lesson.groupId))
      .pipe(takeUntil(this.exit$))
      .subscribe((group) => {
        this.group = group;
      });

    this.store
      .select(gradeSelector.getGradesByGroup(this.data.lesson.groupId))
      .pipe(takeUntil(this.exit$))
      .subscribe((grades) => {
        this.grades = grades;
      });
  }

  ngOnDestroy(): void {
    this.exit$.next();
    this.exit$.complete();
  }

  onCancel(): void {
    this.dialogRef.close(false);
  }

  async submit(): Promise<void> {
    if (
      this.pageForm.invalid ||
      this.group === undefined ||
      this.data.lesson === undefined
    ) {
      return;
    }
    this.loading$ = of(true);
  }

  onGradeChange(event: any) {
    // this.gradeId = event.target.value;
  }
}
